import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { themeColors } from 'themes/clients/baseTheme';

import { NoGoalsTimeline } from 'assets/assetsV1/iconComponents/NoGoalsTimeline';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const ErrorComponent = ({ containerProps, error }) => {
  const action = error?.entity?.action;

  return (
    <Flex
      direction="column"
      padding="24px 4px 16px 4px"
      alignItems="center"
      alignSelf="stretch"
      width="100%"
      {...containerProps}
    >
      <NoGoalsTimeline width="70px" height="60px" />
      <Flex padding="16px 12px" justifyContent="center" alignItems="center" gap="8px" alignSelf="stretch">
        <Box display="flex" flexDirection="column" alignItems="center" gap="12px" flex="1 0 0">
          <Box display="flex" justifyContent="center" alignItems="flex-start" gap="10px" alignSelf="stretch">
            <TextBodyMedium color={themeColors.alerts.negative} bold textAlign="center" flex="1 0 0">
              {error?.message || 'Uh-oh! Looks like an unknown error happened.'}
            </TextBodyMedium>
          </Box>

          <Box display="flex" alignItems="flex-start" gap="4px" alignSelf="stretch">
            {action ? (
              <TextBodyMedium color={themeColors.text.g2} textAlign="center" flex="1 0 0">
                {action}
              </TextBodyMedium>
            ) : (
              <TextBodyMedium color={themeColors.text.g2} textAlign="center" flex="1 0 0">
                You can try generating the results again or contact our support team.
              </TextBodyMedium>
            )}
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};
